export enum BlsCurveName {
  G1 = 'BLS12381_G1',
  G2 = 'BLS12381_G2',
}
